import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import S from './App.module.scss';
import MiseEnPage from './conteneur/MiseEnPage/MiseEnPage';
import ReinitialisationMDP from './conteneur/ReinitialisationMDP/ReinitialisationMDP';
import { LanguageProvider } from './ressources/functionJS/translationService';

import * as url from './ressources/glossaires/glossaire_liens_pages';
import ExportImpressionEcran from './composant/ExportImpressionEcran/ExportImpressionEcran';

function App() {
  useEffect(() => {
    const handleLanguageChange = (e) => {
      if (e.detail?.forceRefresh) {
        // Sauvegarde la position de défilement
        sessionStorage.setItem('scrollPosition', window.scrollY.toString());

        // Force le rafraîchissement
        window.location.reload();
      }
    };

    window.addEventListener('languageChange', handleLanguageChange);

    // Restaure la position de défilement après un rafraîchissement
    const savedPos = sessionStorage.getItem('scrollPosition');
    if (savedPos) {
      window.scrollTo(0, parseInt(savedPos, 10));
      sessionStorage.removeItem('scrollPosition');
    }

    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  return (
    <LanguageProvider>
      <div className={S.Theme}>
        {/* Switch prevents MiseEnPage (and its summary/views/graphs calls) from mounting alongside the export route */}
        <Switch>
          <Route
            path={url.export_impression_ecran}
            component={ExportImpressionEcran}
          />
          <Route
            path="/reinitialisation"
            component={() => <ReinitialisationMDP />}
          />
          <Route path="/" component={() => <MiseEnPage />} />
        </Switch>
      </div>
    </LanguageProvider>
  );
}

export default App;
